import { isBannerRecommendation } from "./guards.js";
const toAction = (action) => {
  if (!action) return null;
  switch (action.__typename) {
    case "RecommendationBannerApplyDiscountCodeAction":
      return { discountCode: action.discountCode };
    case "RecommendationBannerRedirectToLinkAction":
      return { link: { url: action?.link.url, label: action.link.label } };
    case "RecommendationProductRedirectAction":
      return { slug: action.slug };
    case "RecommendationProductAddToCartAction":
      return {
        hasQuantitySelector: action?.hasQuantitySelector,
        sku: action.sku
      };
    default:
      return null;
  }
};
const toImage = (image) => ({
  url: image.url,
  label: image.label,
  dimension: {
    width: image.dimension.width,
    height: image.dimension.height
  }
});
const toPrice = (price) => ({
  value: {
    centAmount: price.value.centAmount,
    fractionDigits: price.value.fractionDigits,
    currencyCode: price.value.currencyCode
  },
  discounted: price.discounted ? {
    value: {
      centAmount: price.discounted.value.centAmount,
      fractionDigits: price.discounted.value.fractionDigits,
      currencyCode: price.discounted.value.currencyCode
    },
    discount: {
      typeId: price.discounted.discount.typeId,
      description: price.discounted.discount.description
    }
  } : null
});
const mergeAndSortRecommendations = (recommendedProducts, recommendedBanners) => {
  const positionAscending = (a, b) => a.position - b.position;
  const recommendations = recommendedProducts.map((product) => ({
    sku: product.sku,
    action: toAction(product.action),
    brand: product.brand || "",
    productType: product.productType,
    brandModel: product.brandModel,
    images: product.images.map((img) => toImage(img)),
    name: product.name || "",
    price: toPrice(product.price),
    promotionLabel: product.promotionLabel || null,
    slug: product.slug,
    tags: product.tags.map((tag) => ({ key: tag.key, value: tag.value })) || [],
    recommendationType: "product"
  }));
  const banners = recommendedBanners.map((banner) => ({
    title: banner.title,
    description: banner.description,
    position: banner.position,
    image: toImage(banner.image),
    action: toAction(banner.action),
    recommendationType: "banner"
  }));
  banners.sort(positionAscending).forEach((banner) => {
    if (isBannerRecommendation(banner)) recommendations.splice(banner.position, 0, banner);
  });
  return recommendations;
};
export {
  mergeAndSortRecommendations
};
//# sourceMappingURL=merge-and-sort-recommendations.js.map
